import {useCallback, useState} from "react";


const useCompetenciesStore = () => {
    const [competences, setCompetences] = useState([]);
    const [performances, setPerformances] = useState([]);
    const [capabilities, setCapabilities] = useState([]);
    const [competenceRegisters, setCompetenceRegisters] = useState([]);


    const addCompetence = useCallback((newCompetence) => {
        if (!newCompetence) {
            return;
        }

        setCompetences(prev => [...new Set(
            [newCompetence, ...prev]
        )]);
    }, []);

    const addPerformance = useCallback((newPerformance) => {
        if (!newPerformance) {
            return;
        }

        setPerformances(prev => [...new Set(
            [newPerformance, ...prev]
        )]);
    }, []);

    const addCapabilities = useCallback((newCapability) => {
        if (!newCapability) {
            return;
        }

        setCapabilities(prev => [...new Set(
            [newCapability, ...prev]
        )]);

    }, []);

    const addCompetenceRegister = useCallback((newCompetenceRegister) => {
        if (!newCompetenceRegister) {
            return;
        };
        setCompetenceRegisters(prev => [...prev, newCompetenceRegister]);
    }, []);

    const removeCompetence = useCallback((competenceForRemove) => {
        setCompetences(competences.filter(c => c !== competenceForRemove));
    }, [competences]);

    const removePerformance = useCallback((performanceForRemove, data) => {
        const currentPerformances = [ ...performances.filter(
              (e) => e !== performanceForRemove
            ),
          ];
          setPerformances(performances.filter(c => c !== performanceForRemove));
          competences.forEach((competenceElement) => {
            const currentCompetences = data.filter(
              (e) => e.competence === competenceElement
            );
            if (currentCompetences.length) {
              const findPerformancesByCompetence = currentCompetences.filter(
                (ccData) => currentPerformances.includes(ccData.performance)
              );
              if (!findPerformancesByCompetence.length) {
                removeCompetence(competenceElement);
                currentCompetences.forEach((ccElement) => {
                  removeCapabilities(ccElement.capability);
                });
              }
            }
          });
    // eslint-disable-next-line
    }, [performances]);

    const removeCapabilities = useCallback((capabilityForRemove) => {
        setCapabilities(capabilities.filter(c => c !== capabilityForRemove));
    }, [capabilities]);

    const clear = () => {
        setCompetences([])
        setPerformances([])
        setCapabilities([])
    }

    return {
        competences,
        performances,
        capabilities,
        competenceRegisters,

        addCompetence,
        addPerformance,
        addCapabilities,
        addCompetenceRegister,

        removeCompetence,
        removePerformance,
        removeCapabilities,
        clear
    }

};

export default useCompetenciesStore;

